import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { dark } from "@clerk/themes";
import { BrowserRouter } from "react-router-dom";
import { CurrencyProvider } from "@/components/currency-provider";
import "../../web/src/app/globals.css";
import { App } from "./app";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const app = (
  <BrowserRouter>
    <div className="aurora" />
    <div className="relative z-10 flex min-h-full flex-1 flex-col">
      <CurrencyProvider><App /></CurrencyProvider>
    </div>
  </BrowserRouter>
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {publishableKey ? (
      <ClerkProvider publishableKey={publishableKey} appearance={{ theme: dark }}>
        {app}
      </ClerkProvider>
    ) : app}
  </React.StrictMode>,
);
